import { render, staticRenderFns } from "./sirketkisiara.vue?vue&type=template&id=1fa2dbc4&"
import script from "./sirketkisiara.vue?vue&type=script&lang=js&"
export * from "./sirketkisiara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports